import { CheckImageIsFile, CheckDataIfExit } from "src/helper/publicFunction";
import { setLoading } from "src/store/customizer/CustomizerSlice";
import { GetFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";
import { PostFunction } from "src/utils/axios_connection";
import { toast } from "react-toastify";

export const GetMediaListMediaGallery =
  ({ callback }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.media_gallery.get_clinic_media_gallery;
      const response = await GetFunction({
        data: {},
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const DeleteEventsMediaGallery =
  ({ mediaTypeId, callback }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.media_gallery.delete;
      const response = await GetFunction({
        data: {},
        Route: link + `/${mediaTypeId}`,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageMediaListMediaGallery =
  ({ callback, values, editMode = false }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let paramID = "";

      var bodyFormData = new FormData();
      // bodyFormData.append("id", values?.id);
      // if (!values.id) {
      // dispatch(setLoading(false));
      // return toast.error("Please select a media id");
      // }
      if (!values.media) {
        dispatch(setLoading(false));
        return toast.error("Please select a media");
      }
      bodyFormData.append("type", "our_clinic_only_image");
      if (
        values?.media &&
        values?.media != null &&
        values?.media != undefined &&
        CheckImageIsFile({ data: values?.media, IsBoolean: true })
      ) {
        bodyFormData.append("media", values?.media);
      } else if (editMode && !values?.media) {
        bodyFormData.append("media", "");
      }
      const response = await PostFunction({
        data: bodyFormData,
        Route: editMode
          ? `${UrlApi.media_gallery.edit}/${paramID}`
          : UrlApi.media_gallery.add,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
        usersRoute: true,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      console.error(err);
      dispatch(setLoading(false));
      callback(false);
    }
  };
